import { defineComponent as _defineComponent } from 'vue'
import { getLayoutData } from '@/apis/baseMaterial'
import { httpRequest } from '@/apis/request'
import { cancelFromBatchList, saveTaskToHistory } from '@/apis/taskList'
import GBaseModal from '@/components/g-base-modal.vue'
import router from '@/router'
import store from '@/store'
import { translate } from '@/util/commonFun'
import { buryPointApi } from '@/util/commonFuncs'
import { dealPreLayoutDataLabelID } from '@/util/dealPaibanData'
import { computed, onMounted, ref, watch } from 'vue'
import Vue from 'vue'

import { getTaskList } from '../module/taskList'
import { TaskType } from '../types/taskCard'
import { getDate } from '../util/batchDataDeal'
import mEmpty from './m-empty.vue'
import MTaskCard from './m-task-card.vue'

interface PropsType {
  batchList: TaskType[]
  total: number
  isLoading: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'm-batch-list',
  props: {
    batchList: null,
    total: null,
    isLoading: { type: Boolean }
  },
  emits: ['onBatchPageChange'],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  batchList: TaskType[]
  total: number
  isLoading: boolean
}




const hasPaiban = computed(() => {
  return Boolean(store.state.batchPaiban)
})

const batchNum = computed(() => {
  return store.state.batchPaiban
    ? store.state.batchPaiban.batchNo
    : `${getDate()}-${Number(store.state.produceTime) + 1}`
})

const currentBatchPage = ref(1)
const taskCardRef = ref<HTMLElement[]>()
const isLoadingPlank = ref(false)
const isShowWorning = ref(false)
const worningText = ref('')
const isEditBatch = ref(false)
const batchNoRef = ref()
const batchNo = ref<any>(batchNum.value)

// TODO 批次号修改 wc
// function handleClickEditBatchNo() {
//   isEditBatch.value = true
//   nextTick(() => {
//     if (batchNoRef.value) {
//       batchNoRef.value.focus()
//     }
//   })
// }

function handleBlurEdit() {
  store.commit('setBatchNo', batchNo.value)
  isEditBatch.value = false
}

function translateLang(key: string) {
  return translate(key) as string
}

async function handleAllOrder() {
  if (!props.batchList.length) {
    Vue.prototype.$message.error(translateLang('taskPage.errTip'))
    return
  }
  buryPointApi('task', 'batch_paiban')
  isLoadingPlank.value = true
  const allBatchList = await getTaskList({
    current_step: 2,
    page: 1,
    limit: 999,
  })
  store.commit('setMaterialTask', allBatchList.taskList)
  store.commit('setFilterMaterialList', null)
  store.commit('setBeforeSearchMaterialList', null)
  store.commit('setBeforeSizeFilterList', null)
  store.commit('setFilterObject', {})

  store.commit('setHasSendToTask', true)
  store.commit('setHasPrintTag', false)
  store.commit('changeHistoryStatus', false)
  store.commit('setIsShowSample', false)
  store.commit('setPaibanData', [])
  store.commit('setIsBatch', true)

  if (store.state.batchPaiban) {
    store.commit('setIsNewPaiban', true)
    isLoadingPlank.value = false
    router.push({
      path: '/materialList',
      query: {
        isBatch: '1',
        paibanJson: props.batchList[0].paiban_json,
      },
    })
  } else {
    // 导入的任务板件JSON数据
    const jsonTaskArr: TaskType[] = []
    // 接收到的任务的房间id
    let roomIds: number[] = []

    let noRoomTaskList: TaskType[] = []
    allBatchList.taskList.forEach((task) => {
      if (!task.plank_json && (!task.roomIds || !task.roomIds.length)) {
        noRoomTaskList.push(task)

        return
      } else if (task.plank_json) jsonTaskArr.push(task)
      else if (task.roomIds) roomIds = roomIds.concat(task.roomIds)
    })

    const emptyDataList: TaskType[] = []
    const realRoomIds = Array.from(roomIds)
    const pro = jsonTaskArr
      .map(async (task) => {
        if (task.plank_json) {
          const res = await httpRequest.get(JSON.parse(task.plank_json).url)
          if (!res.layoutData.length) {
            emptyDataList.push(task)
          }
          return res
        } else {
          return false
        }
      })
      .concat(
        realRoomIds.length
          ? [await getLayoutData({ room_ids: realRoomIds })]
          : []
      )

    Promise.all(pro).then((res) => {
      const resultData = dealPreLayoutDataLabelID(
        res
          .map((r) => {
            const d = r.layoutData
              ? r.layoutData
              : r.data.result_data
              ? r.data.result_data.flat(1)
              : []
            return d
          })
          .flat(1)
      )
      isLoadingPlank.value = false
      // TODO wc 空房间数据是否提示
      // if (emptyDataList.length) {
      //   isShowWorning.value = true
      //   worningText.value = `存在订单【${emptyDataList
      //     .map((task) => task.orderName)
      //     .join('、')}】房间数据为空，无法进行批量生产！`
      // } else
      if (noRoomTaskList.length) {
        isShowWorning.value = true
        worningText.value = `${translateLang(
          'common.order'
        )}【${noRoomTaskList.map((task) => task.orderName)}】${translateLang(
          'taskPage.noRoomTip'
        )}`
      } else if (!resultData.length) {
        isShowWorning.value = true
        worningText.value = translateLang('taskPage.batchEmptyErr')
      } else {
        if (resultData.length > 3000) {
          isShowWorning.value = true
          worningText.value = `${translateLang(
            'taskPage.plankMaxLimit'
          )}(<span style="color:red">${
            resultData.length
          }</span>/${3000})，${translateLang('taskPage.batchWorning')}`
        } else {
          store.commit('setPreLayoutData', resultData)
          store.commit('setIsNewPaiban', true)
          router.push('/materialList')
        }
      }
    })
  }
}
function handleBatchChangePage(page: number) {
  currentBatchPage.value = page
  emits('onBatchPageChange', currentBatchPage.value, 2)
}

function handleTaskWarning(isShow: boolean) {
  isShowWorning.value = isShow
  worningText.value = translateLang('taskPage.emptyErr')
}

function handleCancelBatch(task: TaskType) {
  batchNo.value = `${getDate()}-${Number(store.state.produceTime) + 1}`
  store.commit('setBatchPaiban', null)
  store.commit('setBatchNo', batchNo.value)
  // TODO
  props.batchList.forEach((ts) => {
    if (ts.id == task.id) {
      ts.isInBatchList = false
    }
  })
  store.commit('setBatchPaiban', null)
  emits('onBatchPageChange', currentBatchPage.value, 2)
}

function handleConfirmWorning() {
  isShowWorning.value = false
}

async function handleCancelAllTask() {
  const refList = taskCardRef.value
  const taskIds = props.batchList.map((task) => task.id)
  isLoadingPlank.value = true
  const res = await cancelFromBatchList({
    task_ids: [...taskIds],
    platform: 2,
  })
  currentBatchPage.value = 1
  isLoadingPlank.value = false
  if (res.status == 1) {
    if (refList?.length) {
      refList.forEach((refs: any) => {
        refs.transformAction('left')
      })
    }
    store.commit('setBatchPaiban', null)
    emits('onBatchPageChange', currentBatchPage.value, 2)
    Vue.prototype.$message.success(translateLang('taskPage.operationSuccess'))
    buryPointApi('task', 'clear_all_task')
  } else {
    Vue.prototype.$message.error(translateLang('taskPage.operationFail'))
  }
}

async function handleSaveToHistory() {
  isLoadingPlank.value = true
  const task = props.batchList[0]
  buryPointApi('task', 'save_task')
  const paibanJson = store.state.batchPaiban
  const res = await saveTaskToHistory({
    task_ids: props.batchList.map((task) => task.id),
    platform: task.platform,
    batch_id: task.batch_id,
    task_batch: paibanJson.batchNo,
    process_id: paibanJson.process_setting_id,
  })
  isLoadingPlank.value = false
  if (res.status) {
    Vue.prototype.$message.success(translateLang('taskPage.saveSuccess'))
    store.commit('setBatchPaiban', null)
    emits('onBatchPageChange', currentBatchPage.value, 2)
  } else {
    Vue.prototype.$message.error(translateLang('taskPage.operationFail'))
  }
}

onMounted(async () => {
  if (props.batchList.length) {
    const batchPaibanJson = props.batchList[0].paiban_json
    if (batchPaibanJson) {
      isLoadingPlank.value = true
      const res = await httpRequest.get(batchPaibanJson)
      store.commit('setBatchPaiban', res)
      batchNo.value = res.batchNo ?? props.batchList[0].batchNumber
      store.commit('setBatchNo', batchNo.value)
      isLoadingPlank.value = false
    } else
      batchNo.value = getDate() + '-' + (Number(store.state.produceTime) + 1)
  }
})

watch(
  () => store.state.batchPaiban,
  (val) => {
    batchNo.value = val
      ? val.batchNo ?? props.batchList[0].batchNumber
      : `${getDate()}-${Number(store.state.produceTime) + 1}`
    store.commit('setBatchNo', batchNo.value)
  },
  {
    deep: true,
  }
)

return { __sfc: true,emits, props, hasPaiban, batchNum, currentBatchPage, taskCardRef, isLoadingPlank, isShowWorning, worningText, isEditBatch, batchNoRef, batchNo, handleBlurEdit, translateLang, handleAllOrder, handleBatchChangePage, handleTaskWarning, handleCancelBatch, handleConfirmWorning, handleCancelAllTask, handleSaveToHistory, GBaseModal, mEmpty, MTaskCard }
}

})